/**
 * cn utility — combines class names with tailwind-merge
 *
 * This utility function merges class names using clsx for conditional classes
 * and tailwind-merge to resolve Tailwind CSS conflicts intelligently.
 *
 * @example
 * cn('px-4 py-2', 'bg-blue-500', { 'text-white': true })
 * // => 'px-4 py-2 bg-blue-500 text-white'
 *
 * cn('px-4', 'px-6') // tailwind-merge handles conflict
 * // => 'px-6'
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
